var PD = PD || {};

//------------------------------------------------------------------------------
// Helper functions:
//------------------------------------------------------------------------------
PD.utils = (function(u){
  /**
   * Extend a child class from parent class
   * Stores the parent class in a ._super key on the child's prototype
   *
   * Usage example:
   *
   * function Shape(){}
   * Shape.prototype.sides = 0;
   * Shape.prototype.tellSides = function(){
   *   console.log("I have "+this.sides+" sides.");
   * }
   * 
   * function Rectangle(){
   *   console.log("Created a new rectangle");
   * }
   * Rectangle.prototype.sides = 4;
   * Rectangle = PD.utils.extend(Rectangle, Shape);
   *
   * var x = new Rectangle();
   * x.tellSides();          // > I have 4 sides.
   * x instanceof Shape;     // > true
   * x instanceof Rectangle; // > true
   */
  u.extend = function(Child, Parent){
    // set the prototype of child to an object with parent's prototype as prototype
    // this means our prototype chain becomes:
    //   child -> child's prototype -> parent -> parent's prototype -> ...
    Child.prototype = $.extend(
      Object.create(Parent.prototype), // empty object with parent's prototype as prototype
      Child.prototype, // existing methods on prototype
      {
        _super: Parent
      }
    );

    return Child;
  };

  /**
   * Returns a unique (incremental) integer
   * Should *not* be used for security
   */
  var _unique = 0;
  u.unique = function(){
    return ++_unique;
  };

  /**
   * Finds every value in an object which matches the filter function.
   * @param {Object}   obj     The object to search
   * @param {Function} filter  Should return `true` for all values to be included
   * @param {Boolean}  deep    Whether the objects child-objects should be searched
   * @returns {Array} An array of every object that matched the filter 
   */
  u.objSearch = function objSearch(obj, filter, deep) {
    var outp = [];
    for (var k in obj) {
      if (obj.hasOwnProperty(k)) {
        // add it to the list if it passes the filter
        if (filter(obj[k], obj, k) === true) {
          outp.push(obj[k]);
        }

        // if we want to deep-search, act as a recursive function
        if (deep && obj[k] instanceof Object) {
          outp = outp.concat( objSearch(obj[k], filter, deep) );
        }
      }
    }

    return outp;
  };

  /**
   * Replaces curly bracket, similar to the PHP version found in common.php
   * ('{0} test {foo}', [1]) => '1 test {foo}'
   * ('{0} test {foo}', {foo: 'bar'}) => '{0} test bar'
   */
  u.curlyFormat = function(str, replacements) {
    return str.replace(/{(.+?)}/g, function(wrapped, key){
      if (replacements[key]) {
        return replacements[key];
      }

      return wrapped;
    });
  };

  /**
   * Gets the total scroll offset for an element in respect to the body (or parent)
   * If .scrollTop is set on body (or parent) to the returned value, the element will be shown
   * @param {Element} elm      The element whose offset to get
   * @param {Element} parent  The element to get offset relative to. Default: document.body
   */
  u.scrollOffset = function(elm, parent) {
    parent = parent || document.body;
    var offset = elm.offsetTop;
    while ((elm=elm.offsetParent) && elm !== parent) {
      offset += elm.offsetTop;
    }

    return offset;
  };

  /**
   * Get/set cookies
   */
  u.cookies = {
    /**
     * Set a cookie. If daysUntilExpire isn't given, default to 1 year
     */
    set: function(name, value, daysUntilExpire, path) {
      path = path || "/";

      value = encodeURIComponent(value) + ";path="+path;
      
      if (daysUntilExpire && parseInt(daysUntilExpire) > 0) {
        var expireDate = new Date();
        expireDate.setDate(expireDate.getDate() + parseInt(daysUntilExpire));

        value += ";expires="+expireDate.toUTCString();
      }

      document.cookie = encodeURIComponent(name)+"="+value;
    },
    get: function(name) {
      var cookies = document.cookie.split(";"),
          outp = {};
      for (var i = 0; i < cookies.length; ++i) {
        var ind = cookies[i].indexOf("="),
            cName = cookies[i].substr(0,ind).trim(),
            cVal = cookies[i].substr(ind+1);

        if (cName === name) {
          return decodeURIComponent(cVal);
        } else if (name === undefined) {
          outp[cName] = cVal;
        }
      }

      if (name === undefined) {
        return outp;
      }
    }
  };
  window.setCookie = window.setCookie || u.cookies.set;

  /**
   * Tests if the browser supports a functionality.
   * TODO: possibly replace with Modernizer
   *
   * Possible tests:
   * - "draganddrop"  whether the browser supports file drag-and-drop, including filereader and formdata
   * - "mobile"       while not browser support per se, still included here. Checks useragent for browser/tablet browsers
   */
  u.browserSupport = function (test) {
    var tests = {
      draganddrop: function(){
        var div = document.createElement("div");
        var supportsDrag = ("draggable" in div) || ("ondragstart" in div);
        var supportsReader = ("FormData" in window) && ("FileReader" in window);
        return supportsDrag && supportsReader;
      },
      mobile: function(){
        return _testMobile(navigator.userAgent || navigator.vendor || window.opera);
      },
      touch: function(){
        return ("ontouchstart" in window) || (window.DocumentTouch && document instanceof DocumentTouch);
      }
    };

    if (tests.hasOwnProperty(test)) {
      return tests[test]();
    }
    return undefined;
  };
  // taken from http://stackoverflow.com/a/11381730
  function _testMobile(ua){
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i
        .test(ua) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
        .test(ua.substr(0,4))) {
      return true;
    }
    return false;
  }

  /**
   * Tests if a browser is one of the given.
   * Returns false if not, returns the match if found
   *
   * Pre-defined tests:
   * - "android 4"   the native android browser, Android <= 4 (apparently)
   * - "ie10"         IE <= 10
   *
   * @params {String|Func}  The browsers to test for, either pre-defined or a function
   */
  u.browserTest = (function(){
    var _tests = {
      "android 4": function(ua){
        return ua.indexOf("Mozilla/5.0") > -1 && 
               ua.indexOf("Android ") > -1 && 
               ua.indexOf("AppleWebKit") > -1 &&
               ua.indexOf("Version") > -1;
      },
      "ie10": function(ua){
        return ua.indexOf("MSIE") > -1 &&
               parseInt(ua.split("MSIE")[1]) <= 10;
      }
    };

    return function() {
      var ua = navigator.userAgent;

      for (var i = 0; i < arguments.length; ++i) {
        var k = arguments[i];
        if (typeof k === "string" && _tests[k] && _tests[k](ua)) {
          return k;
        } else if (typeof k === "function" && k(ua)) {
          return k;
        }
      }

      return false;
    };
  })();


  /**
   * Insert a DOM element into a container with animation
   * Optionally scrolls to the newly inserted element
   * @param  {jQuery}  $elm         The element to insert
   * @param  {jQuery}  $parent      The container to insert into
   * @param  {Boolean} scroll     Whether to scroll to the element
   * @param  {Boolean} insertAfter  If true, insert after $parent. If -1, prepend to $parent.
   */
  u.insert = function($elm, $parent, scroll, insertAfter) {
    $elm.addClass("cm-template-fadein");
    // remove fade in animation after it's done
    setTimeout(function(){ $elm.removeClass("cm-template-fadein"); }, 1500);

    // insert in DOM
    if (insertAfter === -1) {
      $elm.prependTo($parent);
    } else if (insertAfter) {
      $elm.insertAfter($parent);
    } else {
      $elm.appendTo($parent);
    }

    // animate scroll if it isn't in viewport
    if (scroll) {
      var elmTop = $elm.offset().top,
          elmH = $elm.height(),
          elmBot = elmTop + elmH;
      var screenTop = $(window).scrollTop(),
          screenBot = screenTop + $(window).height();
      if(screenBot < elmBot || screenTop > elmTop){
        var scrollTop = elmTop - 100, // scroll position if aligning to top
            scrollBot = elmBot - $(window).height() + 25; // if aligning to bottom
        var scrollPos = Math.abs(screenTop - scrollTop) < Math.abs(screenTop - scrollBot) ?
                          scrollTop : scrollBot;

        $("html,body").stop();
        $("html,body").animate({
          scrollTop: scrollPos
        }, 500);
      }
    }
  };

  /**
   * Remove a DOM element, with an (optional) undo notification
   * @param {jQuery} $elm - Element to remove
   * @param {Function|Boolean} onUndo - Function to call when undoing, 
   *                                    or false if we shouldn't undo
   * @param {Object} insertArgs - Object of named arguments to give to PD.utils.insert on undo
   *                              $parent may be a function here, and insertAfter will be overwritten
   * @param {Object} opts - An options object of format:
   * {
   *   $related: {jQuery} - Related elements. These will be removed with the $elm.
   *                        You *MUST* reinsert these yourself (in onUndo)
   *   title: {String} - The title of the undo notification
   *   content: {String} - The content of the undo notification
   *   onRemoved: {Function} - Called when the remove animation is done
   * }
   * @param {jQuery} $related - Related elements. These will be removed with the $elm.
   *                            You *MUST* reinsert those yourself (in onUndo)
   */
  u._undoRemoveNotification = null;
  u.undoableRemove = function($elm, onUndo, insertArgs, opts) {
    var undoable = onUndo !== false;
    insertArgs = insertArgs || {};

    opts = opts || {};
    var $related = opts.$related;

    // animate removal
    $elm.add($related).addClass("cm-template-fadeout");
    setTimeout(function(){
      $elm.add($related).removeClass("cm-template-fadeout");
      PD.templates.remove($elm, undoable);
      if ($related) {
        $related.each(function(){
          PD.templates.remove($(this), undoable);
        });
      }

      if (opts.onRemoved) {
        opts.onRemoved($elm, $related);
      }
    }, 350);

    // add notification if necesarry
    if (undoable) {
      var $prev = $elm.prev(),
          $oldParent = $elm.parent();
      insertArgs.$parent = insertArgs.$parent || $oldParent;

      var isUndone = false;
      var notification = PD.windows.notify.danger(opts.title || "", "", 
          {actions: [{
            text: opts.content || _("Click to undo"),
            click: function(){
              var $parent = insertArgs.$parent;
              if (typeof $parent === "function") {
                $parent = $parent();
              }
      
              // if we're inserting into the same parent
              var insertAfter = false;
              if ($oldParent.is($parent)) {
                // if we were the first child, prepend
                if ($prev.length === 0) {
                  insertAfter = -1;
                // if our old sibling is still inside, insert after that
                } else if ($parent && $parent.is($prev.parent())) {
                  insertAfter = true;
                  $parent = $prev;
                }
              }

              // actually do the insert
              u.insert($elm, $parent, insertArgs.scroll, insertAfter);
              if ($related) {
                $related.addClass("cm-template-fadein");
                // remove fade in animation after it's done
                setTimeout(function(){ $related.removeClass("cm-template-fadein"); }, 1500);
              }
              isUndone = true;
              notification.hide(true);
              if (typeof onUndo === "function") {
                onUndo($elm, $related);
              }
            }
          }],
          // called after the notification is faded out
          removeListener: function(){
            u._undoRemoveNotification = null;
            if (!isUndone) {
              PD.templates.remove($elm);
              if ($related) {
                $related.each(function(){
                  PD.templates.remove($(this));
                });
              }
            }
          }
        });

        // update if an existing notification exists
        if (u._undoRemoveNotification) {
          u._undoRemoveNotification.remove();
          notification.$elm.addClass("cm-notification-updated");
        }
        u._undoRemoveNotification = notification;
    }
  };



  /**
   * Used for i18n
   * Translates a given string (and optionally domain and context) to the users language
   * Language is taken from LANG cookie, or a default if none such exists
   */
  u.lang = function(){

  };
  u.lang.default = (function(){
    var lang = u.cookies.get("LANG");
    // TODO: extract from TLD instead of falling back to simple default
    if (!lang) { lang = "da_DK"; }

    return lang;
  })();

  /**
   * Parses parameters from the current URL (both hash and GET params)
   * If no specific param is given that we should retrieve, returns object
   * in format {key: val, ...}
   * @param {String} name  The name of the param to get
   * @param {String} method  "GET" or "hash". Default both
   */
  u.getUrlParam = (function(){
    var _parsed = {};

    function parse(method) {
      // extract from both the hash and the GET params
      var queryString = "";
      if (method === "GET" || !method) {
        queryString += window.location.search.replace(/\?/, "")+"&";
      }
      if (method === "hash" || !method) {
        queryString += window.location.hash.replace(/^#/, "");
      }
      var split = queryString.split("&");
      // loop through each key
      for (var i = 0; i < split.length; ++i) {
        if (!split[i]) {
          continue;
        }

        // and extract their value
        var _split = split[i].split("=", 2);
        _parsed[_split[0]] = decodeURIComponent((_split[1] || "").replace(/\+/g, " "));
      }
    }

    return function(name, method){
      parse(method);
      return name ? _parsed[name] : _parsed;
    };
  })();

  /**
   * Sets parameters to the current URL (in hash or GET)
   * @param {String} data      An object of key-value sets to set
   * @param {String} method    "GET" or "hash"
   */
  u.setUrlParams = function(data, method){
    var fields = { // window.location[fields[method]]
      "GET": "search",
      "hash": "hash"
    };

    // loop through all data
    for (var k in data) {
      var key = encodeURIComponent(k),
          value = encodeURIComponent(data[k]);

      var escapeRegxp = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,
          keyRegxp = new RegExp("([?#&])"+
                          key.replace(escapeRegxp, "\\$&")+
                          "(=.*?)?(&|$)"
                        ); // eg.: ([?#&])task(=.*?)?(&|$)

      // check if they exist already
      var existing = false;
      for (var field in fields) {
        if (keyRegxp.test(window.location[fields[field]])) {
          existing = field;
          break;
        }
      }

      // use user-given method, existing method or "hash"
      method = method || existing;
      if (!method) {
        method = "hash";
      }

      // set the value
      var str = key+"="+value;
      if (data[k] === undefined) {
        str = "";
      }
      if (existing && existing === method) {
        window.location[fields[method]] = window.location[fields[method]].replace(
          keyRegxp,
          "$1"+str+"$3"
        );
      } else {
        window.location[fields[method]] +=
          (window.location[fields[method]].length ? "&" : "") +
          str;
      }
    }
  };

  /**
   * Clear the parameter from the current URL (both hash and GET params)
   * @param {String} name  The name of the param to clear
   * @param {String} method  "GET" or "hash". Default both
   */
  u.clearUrlParam = function(name, method) {
    var queryString, params;

    if (typeof name === "string" && name !== "") {
      if (method === "hash" || !method) {
        queryString = window.location.hash.replace(/^#/, "") + "";
        params = $.unparam(queryString);

        if (params[name]) {
          delete params[name];

          window.location["hash"] = $.param(params);
        }
      }

      if (method === "GET" || !method) {
        queryString = window.location.search.replace(/\?/, "") + "";
        params = $.unparam(queryString);

        if (params[name]) {
          delete params[name];
          window.location["search"] = $.param(params);
        }
      }
    }
  };

  /**
   * Compare two ISO-8859-1 strings
   * @param {String} a    The first string to compare
   * @param {String} b    The second string to compare
   */
  u.compareStrings = function(a,b) {
    a = a || "";
    b = b || "";

    var alphabet = " 0123456789aáàâbcdeéèêëfghiíìjklmnñoóòôpqrstuúùüûvwxyzäæöøå",
        s1 = a.toLowerCase(),
        s2 = b.toLowerCase(),
        minLgt = Math.min(s1.length,s2.length),
        i = 0;
    
    while (i < minLgt && s1.charAt(i) == s2.charAt(i)) i++;
    if (i == minLgt) {
        return ( s1.length > s2.length)? 1 : ((s1.length == s2.length)? 0 : -1);
    } else {
      return (alphabet.indexOf(s1.charAt(i)) > alphabet.indexOf(s2.charAt(i)))? 1: -1;
    }
  };

  /**
   * Convert a textarea string to HTML.
   * Replaces html entities and new linew/carriage return.
   * @param {String} str    The string to convert
   */
  u.textToHtml = function(str) {
    str = htmlEntities(str);
    str = nlToBr(str);

    return str;
  };

  function htmlEntities(str) {
    str = String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');

    return str;
  }

  function nlToBr(str) {
    str = String(str)
            .replace(/(?:\r\n|\r|\n)/g, '<br>');

    return str;
  }

  u.getTLD = function() {
    return window.location.origin.split('.').pop().toLowerCase();
  }

  return u;
})(PD.utils || {});